import styled from 'styled-components'

import { Button, TypeStyle } from '@syconium/little-miss-figgy'

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;

  @media screen and (max-width: 340px) {
    padding: 0;
  }
`

export const FilterActions = styled.div``

export const FilterIconWrap = styled.span`
  padding-top: 5px;
  padding-inline-end: 5px;
`

export const FilterLabel = styled(TypeStyle.HeadlineExtraExtraSmall)`
  letter-spacing: 2px;
`

export const ActionButton = styled(Button)`
  border: none;
  min-height: 32px;
  padding: 0 12px 0 0;

  @media screen and (max-width: 340px) {
    font-size: 9px;
    min-height: 10px;
    padding: 0 3px;
  }
`

export const TotalWrap = styled(TypeStyle.HeadlineMicro)`
  align-items: center;
  display: flex;
`
